module.exports = "files/powerUp.mp3";